import { Autocomplete, Box, Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Entity from '../../../v3/Common/Entity';
import { MODULE_PERMISSION_ENUM } from '../../../v3/Sidebar/Enum';
import NoAccess from '../../../v3/Common/NoAccess/NoAccess';

const IndustryAndCompanyPicker = ({module_name}) => {
  const dispatch = useDispatch();

  // Get manufacturer and entity from Redux via Entity component
  const {
    selectedSupplier,
    selectedEntity,
    selectedSupplierData,
    selectedEntityInfo,
  } = useSelector(
    (state) => state.entityReducer
  );
  const hasAccess = selectedEntityInfo?.has_access;

  // Auto-dispatch when supplier changes
  useEffect(() => {
    if (selectedSupplier && selectedSupplierData) {
      dispatch({
        type: 'SET_COMPANY_DETAILS_REPORT_REDUCER',
        data: selectedSupplierData,
      });
    }
  }, [selectedSupplier, selectedSupplierData, dispatch]);
  // Auto-dispatch when entity changes
  useEffect(() => {
    if (selectedEntity) {
      dispatch({
        type: 'SET_COMPANY_ENTITY_ID_REDUCER',
        data: selectedEntity,
      });
    }
  }, [selectedEntity, dispatch]);
  return (
    <>
      <Entity
        module_name={module_name}
        supplierLabel="Manufacturer"
        entityLabel="SAP Code"
        forceRefresh={false}
      />
      {!hasAccess && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '60vh',
          }}
        >
          <NoAccess />
        </Box>
      )}
    </>
  );
};

export default IndustryAndCompanyPicker;
